import { render, staticRenderFns } from "./GameInfor.vue?vue&type=template&id=71706a0c&scoped=true"
import script from "./GameInfor.vue?vue&type=script&lang=ts"
export * from "./GameInfor.vue?vue&type=script&lang=ts"
import style0 from "./GameInfor.vue?vue&type=style&index=0&id=71706a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71706a0c",
  null
  
)

export default component.exports